import { useState } from 'react'
import apiClient from '@app/config/axios.config'
import { toast } from '@app/components/ui/Toast/toast'
import { logDataDogAction } from '@app/utils/logger'
import { DATADOG_ACTIONS } from '@app/app-constants'
import type { ProfileRiskRequest } from '../types/riskProfile.types'
import type { ProfilePropertiesRequest } from '../types/riskProfileProperties.types'

export function useExportXlsx(
  request: ProfileRiskRequest | ProfilePropertiesRequest | null,
  endpoint = '/report/risk-profile/xlsx',
) {
  const [isExporting, setIsExporting] = useState(false)

  const exportXlsx = async () => {
    if (!request) return

    setIsExporting(true)

    toast({
      description: 'Generating XLSX export...',
      type: 'info',
    })

    try {
      const response = await apiClient.post(endpoint, request, { responseType: 'blob' })

      const contentDisposition = response.headers['content-disposition']
      const filename = contentDisposition?.match(/filename="(.*?)"/)?.[1] || 'risk-profile.xlsx'

      const url = URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = url
      a.download = filename

      const clickHandler = () => {
        setTimeout(() => {
          URL.revokeObjectURL(url)
          a.removeEventListener('click', clickHandler)
        }, 150)
      }

      a.addEventListener('click', clickHandler, false)
      a.click()

      logDataDogAction(DATADOG_ACTIONS.EXPORT_REPORT, {
        type: 'risk-profile',
        format: 'xlsx',
      })

      toast({
        description: 'XLSX export downloaded successfully.',
        type: 'success',
      })
    } catch (error) {
      toast({
        description:
          'There was an error generating the export. Please notify your Urban Intelligence contact or submit feedback.',
        type: 'error',
      })
    } finally {
      setIsExporting(false)
    }
  }

  return { exportXlsx, isExporting }
}
